import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ILoginUsuario } from '../models/UserSession.model';


const TOKEN_USER = 'LoggedUser';

@Injectable({
  providedIn: 'root'
})

export class TokenService {

  private loggedIn = new BehaviorSubject<ILoginUsuario>(null);

  constructor() {
    if (localStorage.hasOwnProperty(TOKEN_USER)) {
      const session = JSON.parse(localStorage.getItem(TOKEN_USER));
      this.loggedIn.next(session);
    }
  }

  get userLoggedIn(): Observable<ILoginUsuario> {
    return this.loggedIn.asObservable();
  }

  getUserLoggedIn(): ILoginUsuario {
    return this.loggedIn.value;
  }

  setCurrentSession(session: any): void {
    const currentUser = session as ILoginUsuario;
    localStorage.setItem(TOKEN_USER, JSON.stringify(currentUser));
    this.loggedIn.next(session);
  }

  notAuthorized(): void {
    window.localStorage.removeItem(TOKEN_USER);
  }

  signOut(): void {
    this.loggedIn = new BehaviorSubject<ILoginUsuario>(null);
    window.localStorage.clear();
    window.sessionStorage.clear();
  }
}
